import actionTypes from '../constants/actionTypes';

export const startGetHub = () => ({ type: actionTypes.START_GET_HUB });

export const successGetHub = (hub) => ({
  type: actionTypes.SUCCESS_GET_HUB,
  hub,
});

export const errorGetHub = (error) => ({
  type: actionTypes.ERROR_GET_HUB,
  error,
});

export const getHub = (hubId) => {
  return async (dispatch) => {
    dispatch(startGetHub());
    try {
      const [hub] = await (
        await fetch(`${process.env.REACT_APP_ENDPOINT}/hubs?id=${hubId}`)
      ).json();
      const sectionOrder = process.env.REACT_APP_SECTION_ORDER.split(',');
      hub.sections = sectionOrder.map((sectionName) =>
        hub.sections.find(({ name }) => name === sectionName)
      );
      dispatch(successGetHub(hub));
    } catch (error) {
      dispatch(errorGetHub(error));
    }
  };
};
